<template>
  <nav class="general-nav plain-nav">
    <ul class="level-0">
      <li v-for="(link, i) in links" :key="i">
        <a :href="link.destination" :target="link.target">
          {{ link.text }}
        </a>
      </li>
      <li v-if="showLanguageToggle" @click.stop="toggleLanguageDropdown()" class="lang-control">
        <span id="collapsible-lang-list" class="chevron collapsible match-link" :class="{ open: isLanguageToggleOpen }" tabindex="0" role="button" aria-expanded="false">
          <img class="v-align" src="@/assets/icons/network-world.svg" />{{ currentLanguage }}
        </span>
        <div>
          <ul class="level-1" >
            <li v-for="(languageLink, i) in languageListSorted" :key="i"
              :class="{'active' : i==0 }">
              <a :href="languageLink.destination" :target="languageLink.target">{{ languageLink.text }}</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import { baseConsts, contentSiteConsts } from "@/constants.js";

export default {
  name: "site-footer-plain-navigation-section",
  data: function () {
    return {
      languageLinks: [],
      links: [
        {
          text: "Agency Care Desk",
          destination: contentSiteConsts.AGENCY_CARE_DESK,
          target: "_self",
        },
        {
          text: "Safelite locations",
          destination: contentSiteConsts.STORE_LOCATOR,
          target: "_blank",
        },
        {
          text: "Safelite.com",
          destination: contentSiteConsts.SAFELITE_HOME,
          target: "_blank",
        },
      ],
      isLanguageToggleOpen: false,
      showLanguageToggle: true,
    };
  },
  computed: {
    baseSafeliteForAgentsUrl() {
      return baseConsts.SAFELITEFORAGENTS_BASE_URL;
    },
    currentLanguage() {
      return this.isSpanish ? "Español" : "English";
    },
    isSpanish() {
      return window.location.hostname.includes("espanol.");
    },
    languageListSorted() {
      return this.languageLinks.sort((a, b) => a.order - b.order);
    },
    spanishSafeliteForAgentsUrl() {
      return baseConsts.SAFELITEFORAGENTS_SPANISH_URL;
    },
  },
  methods: {
    getEnglishLink(linkDestination) {
      return linkDestination.replace('espanol.', '');
    },
    getLanguageLinks() {
      this.languageLinks = [
        {
          text: "English",
          destination: this.getEnglishLink(baseConsts.SAFELITEFORAGENTS_BASE_URL),
          order: this.isSpanish ? 1 : 0,
          target: "_self",
        },
        {
          text: "Español",
          destination: baseConsts.SAFELITEFORAGENTS_SPANISH_URL,
          order: this.isSpanish ? 0 : 1,
          target: "_self",
        },
      ];
    },
    toggleLanguageDropdown() {
      this.isLanguageToggleOpen = !this.isLanguageToggleOpen;
    },
  },
  mounted() {
    this.getLanguageLinks();
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/navigation/navigation-mixins.scss";
.plain-nav {  
  span {
    color: $secondary;
    font-weight: $font-weight-bold;

    &.match-link {
      font-weight: $font-weight-bold;

      .v-align {
        vertical-align: bottom;
        margin-left: -2px;
        margin-right: 8px;
      }
    }    
  }

  a {
    color: $secondary;
    font-weight: $font-weight-bold;
  }

  .lang-control { 
    ul.level-1 {     
      li {
        a {
          color: #525656;
        }
      }
    }

    .collapsible.open + div {
      > * {
        transition: margin-bottom .3s cubic-bezier(.24,.98,.26,.99);
        margin-bottom: 0;
        max-height: 1000px;
        position: relative;
      }

      &::after {
        height: 35px;
        max-height: 0;
        transition: height .3s cubic-bezier(.76,.37,.67,.9), max-height 0s .3s;
      }
    }
  }

  @extend %general-nav;
}

@include wide-mobile {
  .plain-nav {
    > ul {
      padding: 20px 0 0;
      display: flex;
      flex-wrap: wrap;

      > li {
        display: block;
        width: 50%;
        flex: 0 0 auto;

        > a {
          padding: 0 $page-padding 15px;
        }
      }
    }

    .level-0 {
      > li {
        > span {
          &.open {
            background-size: 100% 100%;
          }

          background-image: linear-gradient(to right, #db0020, #db0020 5px, transparent 5px, transparent);
        }
      }
    }

    .lang-control {
      width: 100%;
      border-top: 1px solid #cacbcc;

      ul.level-1 {     
      li {
        &.active {
          a {
            color: #000;
            font-weight: $font-weight-bold;
            pointer-events: none;
            cursor: default;
          }
        }
      }
    }

      span {
        padding: 20px 15px;
        background: linear-gradient(to right, #0070d1, #0070d1 5px, transparent 5px, transparent);
        background-size: 100% 0;
        background-repeat: no-repeat;
        background-image: linear-gradient(to right, #db0020, #db0020 5px, transparent 5px, transparent);

        &.chevron {
          &::after {
            border-color: #fff transparent;
          }
          &::before {
            border-color: #0070d1;
            right: 17.5px;
          }
        }

        &.collapsible {
          + div {
            overflow: hidden;
            display: flex;

            &::after {
              content: "";
              height: 0;
              max-height: 35px;
              transition: height .3s cubic-bezier(.67,.9,.76,.37);
            }
          }

          &.open {
            + div {
              height: unset;
              max-height: unset;
            }
          }
        }
      }
    }
  }
}

@include tablet {
  .plain-nav {
    a,
    span {
      color: $secondary;
      line-height: 25px;
      text-decoration: none;
      text-decoration: underline rgba($blue-dark, 0);
      display: block;
      margin-bottom: 15px;

      &:hover {
        color: map-get($theme-darks, secondary);
        text-decoration: underline;
        text-decoration: underline rgba($blue-dark, 1);
      }
    }

    .lang-control {
      position: relative;
      transform: translateZ(0);

      ul.level-1 {
        padding: 0;
        width: 100%;

        a {
          border: 1px solid #cacbcc;
          border-bottom-width: 0;
          display: block;
          padding: 15px;
          background: #fff;
          margin-bottom: 0;
        }
      
        li {
          &:first-child {
            > a {
              border-radius: 5px 5px 0 0;
            }
          }

          &:last-child {
            > a {
              border-radius: 0 0 5px 5px;
              border-bottom-width: 1px;
            }
          }

          &.active {
            a {
              color: #000;
              font-weight: $font-weight-bold;
              pointer-events: none;
              cursor: default;
              border-left: 5px solid #db0020;
              padding-left: 10px;
            }
          }
        }
      }

      > div {
        left: 0;
        right: auto;
        position: absolute;
        border-top: none;
        top: 30px;
        min-width: 125px;
        box-shadow: 0 1px 5px rgba(0, 0, 0, .2);
        border-radius: 5px;
      }

      span {
        &.chevron {
          &::after {
            content: "";
            display: block;
            position: absolute;
            border-style: solid;
            top: 50%;
            transition: .3s all linear;
            height: 22px;
            width: 19px;
            border-width: 9px;
            margin-top: -9px;
            right: -3px;
            border-color: #fff transparent;
          }
          &::before {
            border-color: #0070d1;
            width: 8px;
            height: 8px;
            margin-top: -6px;
            right: 2px;
            border-width: 0 1px 1px 0;
            border-radius: 0;
            box-shadow: inset 0 0 1px rgba(219, 0, 32, .5);
          }

          &.open {
            &::after {
              margin-top: -12px;
            }
            &::before {
              margin-top: -1px;
              border-color: #0063ad;
              border-width: 1px 0 0 1px;
              transition: .3s all linear, 0s border-right-width .3s, 0s border-bottom-width .3s, 0s border-top-width, 0s border-left-width;
            }
          }
        }
      }
    }
  }
}
</style>